<script setup>
import { ref } from 'vue';
import router from '@/router';
import { useMutation } from '@tanstack/vue-query';
import { API } from '@/services/index';
import { VERIFY_USER_MUTATION } from '@/services/auth/mutations/index.js';
import { RESEND_VERIFYCODE_MUTATION } from '@/services/auth/mutations/index.js';
import { useAuthStore } from '@/stores/auth.store.js';
import Cookies from 'js-cookie';

const otp = ref('');
const verifyErrors = ref(null);
const isLoading = ref(false);
const isFormValid = ref(false);
const route = useRoute();
const token = route.query?.token ?? null;

const onSubmitHandle = () => {
  isLoading.value = true;

  const payload = {
    code: otp.value,
    email: localStorage.getItem('_pup_new_user_email'),
    invite_token: token
  };
  verifyUserMutation.mutateAsync(payload);
};

const verifyUserMutation = useMutation({
  mutationFn: async (payload) => {
    return await API.sendQuery('/graphql', VERIFY_USER_MUTATION, payload);
  },
  onSuccess: (data) => {
    console.log(data);
    if (data.data.data.verifyUser) {
      useAuthStore().login(data.data.data.verifyUser.token);
      //Cookies.set('_pup_access_token', data.data.data.verifyUser.token, {
      //  expires: 7,
      //  sameSite: 'strict',
      //  secure: true
      //});
      localStorage.removeItem('_pup_new_user_email'); //cleanup in aisle 41

      if (data.data.data.verifyUser.redirect_url) {
        router.push(data.data.data.verifyUser.redirect_url);
      } else if (data.data.data.verifyUser.new_user) {
        localStorage.setItem('_pup_new_user', true);
        router.push('/onboard');
      } else {
        // user was probably imported from old backstage. Just send them to the dashboard.
        router.push('/');
      }
    }
    if (data.data.errors) {
      isLoading.value = false;
      verifyErrors.value = data.data.errors[0].extensions.debugMessage;
    }
  }
});

const resendVerifyCodeMutation = useMutation({
  mutationFn: async (payload) => {
    return await API.sendQuery('/graphql', RESEND_VERIFYCODE_MUTATION, payload);
  },
  onSuccess: (data) => {
    if (data.data.data.resendUserVerification) {
      // thumbs up
    }
  }
});

const resendCode = () => {
  let payload = {
    email: localStorage.getItem('_pup_new_user_email')
  };
  resendVerifyCodeMutation.mutateAsync(payload);
};
</script>

<template>
  <h3 class="text-primary-blue tw-text-center tw-font-mono tw-text-lg tw-font-bold">Verify Your Account</h3>
  <div class="tw-text-center" style="font-size: 13px">
    We’ve sent you a message to the email address you have provided us. Please enter the code you see.
  </div>
  <p v-if="verifyErrors" class="tw-mb-1 tw-text-center tw-text-[0.8rem] tw-text-red-500">
    {{ verifyErrors }}
  </p>
  <v-form class="" ref="verifyForm" v-model="isFormValid" @submit.prevent="onSubmitHandle">
    <div class="text-primary-blue font-weight-regular mt-5 tw-text-center" style="font-size: 13px">Please Enter Your Verification Code</div>
    <v-row>
      <v-col cols="12">
        <v-otp-input v-model="otp" type="number" variant="solo" length="6"></v-otp-input>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-btn
          color="primary-blue"
          size="large"
          rounded="lg"
          block
          flat
          class="text-capitalize font-weight-bold"
          style="letter-spacing: 0px"
          type="submit"
          :loading="isLoading"
        >
          Verify
        </v-btn>
      </v-col>
    </v-row>
  </v-form>
  <div class="tw-mt-3 tw-w-full tw-text-center tw-text-[0.813rem] tw-font-semibold tw-text-primary-blue">
    <span class="tw-font-normal">No access Code? send it again</span>
    <a class="cursor-pointer tw-ml-1 tw-text-[0.813rem] tw-font-bold" @click="resendCode()"> Resend </a>
  </div>
</template>

<style scoped></style>
